var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFiles = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30871_55840)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9173 1.00066H4.37249C4.00115 1.0106 3.6487 1.16836 3.39171 1.43965C3.13472 1.71095 2.99396 2.07386 3.00002 2.44953V20.7918C2.99396 21.1675 3.13472 21.5304 3.39171 21.8017C3.6487 22.073 4.00115 22.2307 4.37249 22.2407H19.6272C19.9985 22.2307 20.351 22.073 20.608 21.8017C20.8649 21.5304 21.0057 21.1675 20.9996 20.7918V7.00854L14.9173 1.00066ZM13.875 8.20687L14.2498 2.39643L19.7247 7.8278L13.875 8.20687Z",
    fill: "#445F6F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30871_55840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFiles, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/files.46a70d28.svg";
export { ForwardRef as ReactComponent };